import * as PropTypes from 'prop-types';
export var propTypes = {
    className: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.element.isRequired).isRequired,
        PropTypes.element.isRequired
    ]),
    disabled: PropTypes.bool,
    icon: PropTypes.any
};
//# sourceMappingURL=types.js.map